import { IonChip } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Chip = styled(IonChip)`
  cursor: pointer;
  border-radius: 8px;
  padding: 0 16px;
  color: ${myPalette.black.main};
  background: ${myPalette.limeGreen.main};
  margin: 0;
  height: 40px;

  &:hover {
    background-color: ${myPalette.limeGreen.main};
  }
`

export const Amount = styled('div')`
  margin-left: 8px;
  font-weight: 500;
  font-size: 18px;
`
